// removed by extract-text-webpack-plugin
module.exports = {"MainMenuItem":"_1ZcYEnaXoKB65T6mwvahtQ","MainMenuItemSelected":"_3C9SEEOxbS4Rr2EXyiJ7sr"};


//////////////////
// WEBPACK FOOTER
// ./src/layout/Dashboard/RightPanel/MainMenu/style.css
// module id = 2448
// module chunks = 0